module.exports = __webpack_public_path__ + "static/img/19056A_1_C_20221227_LC.fca4f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19056A_1_C_20221227_LC.png
// module id = 8ITW
// module chunks = 0